import React, { useRef, useState } from 'react'

import { ISessionScreenNumberState, ISessionUseScreenNumberState } from '../types'

const useScreenNumberState: ISessionUseScreenNumberState = () => {
  const [_, refresh] = useState<object>(null)
  const stateRef = useRef<ISessionScreenNumberState>(null)

  if (null === stateRef.current) {
    let disabled = false
    stateRef.current = {
      screenNumberRef: React.createRef<number>(),
      setScreenNumber: screenNumber => {
        if (!disabled) {
          stateRef.current.screenNumberRef.current = screenNumber
          refresh({})
        }
      },
      baseScreenNumbersStackRef: React.createRef<number[]>(),
      disable(silent = false) {
        stateRef.current.reset(true)
        disabled = true
        if (!silent) {
          refresh({})
        }
      },
      get disabled() {
        return disabled
      },
      reset(silent = false) {
        stateRef.current.screenNumberRef.current = 0
        stateRef.current.baseScreenNumbersStackRef.current = []
        disabled = false
        if (!silent) {
          refresh({})
        }
      }
    } as const
    stateRef.current.reset(true)
  }

  return stateRef.current
}

export default useScreenNumberState
